/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ service: NonNullable<unknown> }} Toast_Service_Unavailable_Description__ServiceInputs */

const en_toast_service_unavailable_description__service = /** @type {(inputs: Toast_Service_Unavailable_Description__ServiceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The ${i?.service} service is temporarily unavailable. Please try again later.`)
};

const nl_toast_service_unavailable_description__service = /** @type {(inputs: Toast_Service_Unavailable_Description__ServiceInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`De ${i?.service}-service is tijdelijk niet beschikbaar. Probeer het later opnieuw.`)
};

/**
* | output |
* | --- |
* | "The {service} service is temporarily unavailable. Please try again later." |
*
* @param {Toast_Service_Unavailable_Description__ServiceInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
const toast_service_unavailable_description__service = /** @type {((inputs: Toast_Service_Unavailable_Description__ServiceInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Service_Unavailable_Description__ServiceInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_service_unavailable_description__service(inputs)
	return en_toast_service_unavailable_description__service(inputs)
});
export { toast_service_unavailable_description__service as "toast_service_unavailable_description_$service" }